import React, { useEffect, useMemo, useRef, useState } from "react";
import { MaterialReactTable, useMaterialReactTable, MRT_ExpandAllButton } from "material-react-table";
import { AddIcon, Badge, Box, Button, Chip, CloseIcon, DeleteIcon, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, EditIcon, Fab, Grid, IconButton, Menu, MenuItem, Slide, Stack, Tooltip, } from "../../styles/MaterialUI";
import "../.././styles/CustomStyle.css";
import axios from "axios";
import apiConstants from "../../constants/apiConstants";
import ContentProgress from "../contentprogress/ContentProgress";
import { reloadOn, reloadOff } from "../Redux/Features/reloadMetricsSlice";
import { useDispatch, useSelector } from "react-redux";
import CreateScreenDialog from "../ScreenComponents/CreateScreenDialog";
import EditScreenDialog from "../ScreenComponents/EditScreenDialog";
import { getAppData, getEditScreenData } from "../Redux/Features/editScreenDataSlice";
import MapScreenDialog from "../ScreenComponents/MapScreenDialog";
import { getMapScreenData } from "../Redux/Features/mapScreenDataSlice";
import { setScreenGlobalSearch } from "../Redux/Features/searchParamsSlice";
import { showAlertPopup } from "../Redux/Features/showAlertSlice";
import { useOrgConfigData } from "../../hooks/useOrgConfigData";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ScreenTable = () => {
  const dispatch = useDispatch();
  const { reloadStatus, screenUiid, screenStatus, deviceStatus } = useSelector((state) => state.reloadMetrics);
  const { userToken } = useSelector((state) => state.userToken);
  const { userRole, isInternalUserMapped } = useSelector((state) => state.userLogin);
  const orgConfig = useOrgConfigData("screenTable");
  const {
    org_properties: org_configurations
  } = orgConfig || {};
  const { screenGlobalSearchData } = useSelector((state) => state.searchParams);
  const [isLoading, setIsLoading] = useState(false);
  const [tableValues, setTableValues] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [addScreenAlert, setAddScreenAlert] = useState(false);
  const [rowData, setRowData] = useState({});
  const headers = { Authorization: `Bearer ${userToken}` };
  const [openProgress, setOpenProgress] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const modalRef = useRef(null);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight * 0.5);
  const contentTypeMap = { "image": "Image", "video": "Video", "dashboard": "IntelliDash Dashboard", "content_playlist": "Content Playlist", "open_url": "Open URL" };
  const [progressData, setProgressData] = useState(null);
  const [newScreenModal, setNewScreenModal] = useState(false);
  const [mapScreenModal, setMapScreenModal] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [publishAlert, setPublishAlert] = useState(false);
  const [editScreenModal, setEditScreenModal] = useState(false);
  const mapScreenInputs = { id: [], screenname: [] };
  const [mapScreenModalInputs, setMapScreenModalInputs] = useState(mapScreenInputs);
  const [multipleScreenMappingData, setMultipleScreenMappingData] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [initialLoad, setInitialLoad] = useState(false);
  // ── Limits derived from org_properties ──────────────────────────────────
  const aristocastLimits = org_configurations?.aristocast_limits ?? {};
  const maxScreens = aristocastLimits.max_limit_of_aristocast_screens ?? 0;

  const getIntegrationData = async () => {
    const apiResponse = await axios.post(`${apiConstants.GET_API_URL}getIntegrations`, {}, { headers });
    const { data } = apiResponse.data;
    return data;
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const integrationData = await getIntegrationData();
      const response = await axios.post(`${apiConstants.GET_API_URL}getScreens`, { org_id: "test" }, { headers });
      const { data } = response.data;

      const updatedData = data.map(item => {
        let ic_display_status;
        let ic_filter_tags;

        if (item.ic_screen_status === "0") {
          ic_display_status = "Deactivated";
        } else if (item.ic_screen_status === "2") {
          ic_display_status = (item.ic_device_screen_status === 0 || item.ic_device_screen_status === null) ? "Offline" : "Paired";
        } else if (item.ic_screen_status === "1") {
          if (item.ic_device_screen_status === 0 || item.ic_device_screen_status === null) {
            ic_display_status = "Offline";
          } else if (item.ic_device_screen_status === 2) {
            ic_display_status = "Idle";
          } else if (item.ic_device_screen_status === 1) {
            ic_display_status = "Active";
          } else {
            ic_display_status = "Active";
          }
        } else {
          ic_display_status = "Offline";
        }
        ic_filter_tags = item.ic_tags.join(",").replace(",", ";");
        item.mapping_createdon = formatDate(item.mapping_createdon);
        item.mapping_updatedon = formatDate(item.mapping_updatedon);
        item.screen_createdon = formatDate(item.screen_createdon);
        item.ic_content_type = item.ic_org_integration_id ?
          integrationData?.find(data => data.ic_org_integration_id === item.ic_org_integration_id).integration_name : contentTypeMap[item.ic_content_type];

        return { ...item, ic_display_status, ic_filter_tags };
      });

      setTableValues(updatedData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const formatDate = (input) => {
    if (input) {
      const newDate = new Date(input);
      return newDate.toLocaleString();
    }
    return input;
  }

  useEffect(() => {
    if (reloadStatus === true) {
      const updatedData = tableValues.map(item => {
        if (item.screen_uiid === screenUiid) {
          let ic_display_status;
          if (screenStatus === "0") {
            ic_display_status = "Deactivated";
          } else if (screenStatus === "2") {
            ic_display_status = (deviceStatus === "0" || deviceStatus === null) ? "Offline" : "Paired";
          } else if (screenStatus === "1") {
            ic_display_status = (deviceStatus === "0" || deviceStatus === null) ? "Offline" :
              (deviceStatus === "1") ? "Active" : "Idle";
          }
          return { ...item, ic_display_status };
        }
        return item;
      });

      setTableValues(updatedData);
      dispatch(reloadOff());
    }
  }, [reloadStatus])

  useEffect(() => {
    fetchData();
    setGlobalFilter(screenGlobalSearchData);
    setInitialLoad(true);
  }, []);

  const handleCloseProgress = () => {
    setOpenProgress(false);
  }

  const handleOpenAddScreen = () => {
    userRole === "admin" ? setNewScreenModal(true) : setAddScreenAlert(true)
  };

  const handleAddScreenModal = async (formData) => {
    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}addNewScreen`, formData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.statusCode === 200) {
        setNewScreenModal(false);
        dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Screen Added Successfully" }));
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleModifyScreenModal = async (formData, screenChanges, mapScreenModalInputs) => {
    setMapScreenModalInputs(mapScreenModalInputs);
    try {
      if (screenChanges.screen && screenChanges.mapping) {
        const response = await axios.post(`${apiConstants.GET_API_URL}updateScreen`, formData,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.statusCode === 200) {
          handleConfirmPublish(screenChanges);
        }
      } else if (screenChanges.mapping) {
        handleConfirmPublish(screenChanges);
      } else {
        const response = await axios.post(`${apiConstants.GET_API_URL}updateScreen`, formData,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.statusCode === 200) {
          setEditScreenModal(false);
          setTimeout(() => { dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Screen Updated Successfully" })); }, 250);
        }

        fetchData();
      }
      setRowData({});
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleDeleteScreenRecords = (row) => {
    const { ic_screen_status, ic_display_status } = row.original;
    if (userRole !== "admin") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Admin privileges required to delete screen" }));
      return;
    }
    if (ic_display_status !== "Deactivated" && ic_screen_status !== "2") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Only screens with Deactivated or Paired status can be deleted" }));
      return;
    }
    setRowData(row.original);
    setConfirmDialog(true);
  };

  const handleConfirmDelete = async () => {
    const { screen_uiid } = rowData;
    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}deleteScreen`, { screen_uiid }, { headers });

      if (response.data.statusCode === 200) {
        setConfirmDialog(false);
        dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Screen Deleted Successfully" }));
        dispatch(reloadOn());
      }
      fetchData();
      setRowData({});
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleCancelDelete = () => {
    setRowData({});
    setConfirmDialog(false);
  };

  const handleScreenMapping = () => {
    const screen_uiid = Object.keys(rowSelection).map(String);
    const selectedData = tableValues.filter((data) => screen_uiid.includes(data.screen_uiid));
    const allowMapping = validateScreenMapping(selectedData);

    if (!allowMapping) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Mapping is only permitted for screens that are not deactivated" }));
      return;
    }

    dispatch(getMapScreenData({ rowSelection, tableValues }));
    setMapScreenModal(true);
  };

  const handleConfirmPublish = async (screenChanges) => {
    const { contentType, contentName, screenuiid, contentID, contentNotes } = screenChanges;
    setProgressData({ screen_Uiids: screenuiid, content_id: contentID, contentType: contentType });

    if (!contentType) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select content type" }));
      return;
    }

    if (contentType && !contentName) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select content" }));
      return;
    }
    const payload = { screen_uiids: screenuiid, content_id: contentID, mapping_notes: contentNotes };

    try {
      setIsPublishing(true);
      const response = await axios.post(`${apiConstants.GET_API_URL}createMapping`, payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      if (response.data.statusCode === 200) {
        setMapScreenModal(false);
        setEditScreenModal(false);
        setOpenProgress(true);
        setPublishAlert(false);
        setRowSelection({});
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    } finally {
      setIsPublishing(false);
    }
  };

  const validateScreenDeletion = (data) => {
    return data.every(item => item.ic_display_status === "Deactivated" || item.ic_screen_status === "2");
  };

  const validateScreenMapping = (data) => {
    return data.every(item => item.ic_display_status !== "Deactivated");
  };

  const validateActivateDeactivate = (data) => {
    const activate = data.every(item => item.ic_display_status === "Deactivated");
    const deactivate = data.every(item => item.ic_display_status === "Active" || item.ic_display_status === "Offline" || item.ic_display_status === "Idle");

    return [activate, deactivate];
  }

  const handleDeleteScreens = async () => {
    const rowId = Object.keys(rowSelection);
    if (userRole !== "admin") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Admin privileges required to delete screens" }));
      return;
    }
    if (rowId.length === 0) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select at least one screen in the list" }));
      return;
    }

    const selectedRows = tableValues.filter((data) => rowId.includes(data.screen_uiid));
    const allowDeletion = validateScreenDeletion(selectedRows);

    if (!allowDeletion) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Only screens with Deactivated or Paired status can be deleted" }));
      return;
    }

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}deleteScreens`, { screen_uiids: rowId }, { headers });

      if (response.data.statusCode === 200) {
        dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Selected Screens Deleted Successfully" }));
        setRowSelection({});
        dispatch(reloadOn());
      }
      fetchData();

    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleActivateDeactivate = async () => {
    const rowId = Object.keys(rowSelection);
    if (rowId.length === 0) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select at least one screen in the list" }));
      return;
    }

    const selectedRows = tableValues.filter((data) => rowId.includes(data.screen_uiid));
    // Remove paired status

    const filteredRows = selectedRows.filter(
      item => String(item.ic_screen_status).trim() === "2"
    );

    if (filteredRows.length > 0) {
      dispatch(showAlertPopup({
        isOpen: true,
        severity: "error",
        message: "Paired screens cannot be activated or deactivated"
      }));
      return;
    }

    const [activate, deactivate] = validateActivateDeactivate(selectedRows);

    if (!activate && !deactivate) {
      dispatch(showAlertPopup({
        isOpen: true, severity: "error",
        message: "The Activate/Deactivate process is only applicable to screens with an Active, Deactivated, Idle or Offline status"
      }));
      return;
    }

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}changeScreenStatus`, { screen_uiids: rowId }, { headers });

      if (response.data.statusCode === 200) {
        dispatch(showAlertPopup({
          isOpen: true, severity: "success",
          message: activate ? "Selected Screens Activated Successfully" : "Selected Screens Deactivated Successfully"
        }));
        setRowSelection({});
        dispatch(reloadOn());
      }
      else if (response.data.statusCode === 207) {
        dispatch(showAlertPopup({
          isOpen: true, severity: "error",
          message: response.data.message
        }));
        setRowSelection({});
        dispatch(reloadOn());
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  }

  const columns = useMemo(
    () => [
      {
        header: "Thumbnail",
        accessorKey: "ic_thumbnail_url",
        size: 120,
        enableGlobalFilter: false,
        enableColumnFilter: false,
        id: "thumbnail",
        muiTableBodyCellProps: { align: "center" },
        enableSorting: false,
        Cell: ({ cell }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              height: "100%",
            }}
          >
            <img
              alt="avatar"
              height={30}
              width={70}
              src={
                cell?.getValue()
                  ? `data:image/jpeg;base64,${cell.getValue()}`
                  : "NoImage.png"
              }
              loading="lazy"
              style={{ borderRadius: "10%", objectFit: "cover" }}
            />
          </Box>
        ),
      },
      {
        header: "Screen Name",
        accessorKey: "ic_screen_name",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
        columnFilterModeOptions: ["contains", "startsWith", "endsWith", "equals", "notEquals"],
      },
      {
        header: "Screen UIID",
        accessorKey: "screen_uiid",
        size: 165,
      },
      {
        header: "Status",
        accessorKey: "ic_display_status",
        size: 100,
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ renderedCellValue }) => (
          <Stack direction="row" spacing={1}>
            <Chip label={renderedCellValue || "Offline"} size="small"
              sx={{
                backgroundColor:
                  renderedCellValue === "Paired"
                    ? "#0d45a5"
                    : renderedCellValue === "Deactivated"
                      ? "red"
                      : renderedCellValue === "Offline"
                        ? "#ff8000"
                        : renderedCellValue === "Active"
                          ? "green"
                          : renderedCellValue === "Idle"
                            ? "gray"
                            : "#ffcb7f",
                width: "100px",
                color: "#fff",
              }}
            />
          </Stack>
        ),
      },
      {
        header: "Content Type",
        accessorKey: "ic_content_type",
        size: 155,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Content Name",
        accessorKey: "ic_content_name",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Location",
        accessorKey: "ic_location",
        size: 120,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Building",
        accessorKey: "ic_building",
        size: 120,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Floor",
        accessorKey: "ic_floor",
        size: 120,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Room",
        accessorKey: "ic_room",
        size: 120,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Tags",
        accessorKey: "ic_tags",
        size: 120,
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ renderedCellValue }) => {
          const [anchorEl, setAnchorEl] = useState(null);
          const arrayLength = renderedCellValue.length;

          return (
            <Stack spacing={1}>
              {arrayLength > 0 && (
                <>
                  <Badge
                    color="primary"
                    onClick={arrayLength > 1 ? (e) => setAnchorEl(e.currentTarget) : () => { }}
                    badgeContent={arrayLength > 1 ? `+${arrayLength - 1}` : 0}
                    style={{ cursor: "pointer" }}
                  >
                    <Chip size="small" variant="filled" label={renderedCellValue[0]} color="info" />
                  </Badge>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                    {renderedCellValue.map((item, index) => {
                      return <MenuItem key={index} onClick={() => setAnchorEl(null)} style={{ marginTop: 0 }}>{item}</MenuItem>
                    })}
                  </Menu>
                </>
              )}
            </Stack>
          )
        },
      },
      {
        header: "Screen Created By",
        accessorKey: "screen_createdby",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Screen Created On",
        accessorKey: "screen_createdon",
        sortingFn: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.getValue(columnId));
          const dateB = new Date(rowB.getValue(columnId));
          return dateA - dateB;
        },
        sortDescFirst: false, // FORCE first click = ASC
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Mapping Created By",
        accessorKey: "mapping_createdby",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Mapping Created On",
        accessorKey: "mapping_createdon",
        sortingFn: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.getValue(columnId));
          const dateB = new Date(rowB.getValue(columnId));
          return dateA - dateB;
        },
        sortDescFirst: false, // FORCE first click = ASC
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Mapping Last Updated By",
        accessorKey: "mapping_updatedby",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Mapping Last Updated On",
        accessorKey: "mapping_updatedon",
        sortingFn: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.getValue(columnId));
          const dateB = new Date(rowB.getValue(columnId));
          return dateA - dateB;
        },
        sortDescFirst: false, // FORCE first click = ASC
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Display Tags",
        accessorKey: "ic_filter_tags",
      },
    ],
    []
  );

  const handleRowEdit = async (row) => {
    const { screen_uiid } = row.original;
    dispatch(getEditScreenData(row.original));

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}getScreenMessages`, { screen_uiid: screen_uiid }, { headers });
      const { data } = response.data;
      dispatch(getAppData(data.alert_messages));
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
    setEditScreenModal(true);
  };

  const handleCloseModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setEditScreenModal(false);
      setNewScreenModal(false);
      setMapScreenModal(false);
      setConfirmDialog(false);
      setPublishAlert(false);
      setRowData({});
      setMapScreenModalInputs(mapScreenInputs);
      setRowSelection({});
    }
  };

  useEffect(() => {
    if (!globalFilter && initialLoad) {
      dispatch(setScreenGlobalSearch(""));
    }
  }, [globalFilter]);

  const handleGlobalSearch = (event) => {
    const { value } = event.target;
    dispatch(setScreenGlobalSearch(value));
    setGlobalFilter(value);
  }

  // ── Max-contents guard ───────────────────────────────────────────────────
  /**
   * Call this before opening the "Add Content" flow.
   * Returns true if the user can proceed, false if they've hit their limit.
   */
  const checkMaxScreensLimit = () => {

    if (tableValues.length >= maxScreens) {
      showAlert(
        "error",
        "You have reached your maximum screen limit. Delete existing screens to add a new one or upgrade to add more screens."
      );
      return false;
    }
    handleOpenAddScreen();
  };

  const table = useMaterialReactTable({
    columns,
    data: tableValues,
    getRowId: (row) => row.screen_uiid,
    onRowSelectionChange: setRowSelection,
    onGlobalFilterChange: setGlobalFilter,
    muiSearchTextFieldProps: {
      sx: { minWidth: '300px' }, variant: 'outlined', value: screenGlobalSearchData, onChange: handleGlobalSearch
    },
    state: { rowSelection, isLoading: isLoading, globalFilter },
    filterFns: {
      myCustomFilterFn: (row, id, filterValue) =>
        row.getValue(id)?.toString().toLowerCase().trim().includes(filterValue?.toString().toLowerCase().trim())
    },
    globalFilterFn: 'myCustomFilterFn',
    displayColumnDefOptions: {
      "mrt-row-expand": {
        Header: () => (
          <Stack direction="row" alignItems="center">
            <MRT_ExpandAllButton table={table} />
            <Box>Groups</Box>
          </Stack>
        ),
        GroupedCell: ({ row, table }) => {
          const { grouping } = table.getState();
          return row.getValue(grouping[grouping.length - 1]);
        },
        enableResizing: true,
        size: 200,
      },
      "mrt-row-select": {
        visibleInShowHideMenu: false,
        size: 20,
      },
      "mrt-row-actions": {
        visibleInShowHideMenu: false,
      },
    },

    renderTopToolbarCustomActions: () => (
      <Stack spacing={1} direction="row" className="tab-responsive">
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={checkMaxScreensLimit}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": { backgroundColor: "#0d45a5", color: "#fff" }
          }} disabled={isInternalUserMapped === 1}
        >
          <AddIcon className="fab-btn-icon-responsive" sx={{ fontSize: "20px", mr: 0.5 }} />
          Add Screen
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={handleScreenMapping} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Map Screens to Content
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={handleActivateDeactivate} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Activate / Deactivate Screens
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={handleDeleteScreens} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Delete Screens
        </Fab>
      </Stack>
    ),
    renderRowActions: ({ row }) => (
      <Box sx={{ display: "flex" }}>
        <Tooltip title="Delete">
          <IconButton color="error" style={{ display: isInternalUserMapped === 1 ? "none" : "inline-flex" }} onClick={() => handleDeleteScreenRecords(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton color="inherit" onClick={() => handleRowEdit(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    positionToolbarDropZone: "bottom",
    enableEditing: true,
    enableRowActions: true,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableGrouping: false,
    enableFacetedValues: true,
    enableColumnResizing: true,
    enableColumnOrdering: false,
    enableColumnFilterModes: true,
    groupedColumnMode: "remove",
    positionToolbarAlertBanner: "bottom",
    enableExpandAll: true,
    muiTableContainerProps: {
      sx: { maxHeight: `${screenHeight}px` },
    },
    initialState: {
      density: "compact",
      expanded: false,
      pagination: { pageIndex: 0, pageSize: 50 },
      sorting: [{ id: "ic_screen_name", desc: false }],
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-actions"],
      },
      columnVisibility: { ic_filter_tags: false },
      showGlobalFilter: screenGlobalSearchData ? true : false,
    },
    muiCircularProgressProps: { sx: { color: "#003366" }, thickness: 5, size: 55 },
    muiSkeletonProps: { animation: "pulse", height: 28 },
    localization: { dropToGroupBy: "Drag a column here to group by it", thenBy: " ", },
    muiPaginationProps: { rowsPerPageOptions: [10, 50, 100] },
    muiTableHeadCellProps: {
      sx: {
        '& .Mui-TableHeadCell-Content-Wrapper': {
          whiteSpace: "wrap"
        },
      }
    },
    muiSelectCheckboxProps: ({ row }) => ({
      inputProps: {
        id: `checkbox-${row.original.screen_uiid}`,
      },
    }),
    muiSelectAllCheckboxProps: () => ({
      inputProps: {
        id: `checkbox-screen-head`,
      },
    }),
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight * 0.5);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const showAlert = (alertType, errorMessage) => {
    dispatch(showAlertPopup({ isOpen: true, severity: alertType, message: errorMessage }));
  }

  const hanldeCloseAddScreenModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setNewScreenModal(false);
    }
  }

  const hanldeCloseEditScreenModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setEditScreenModal(false);
    }
  }

  const hanldeCloseMapScreenModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setMapScreenModal(false);
      setRowSelection({});
    }
  }

  const handleMappingConfirmation = (mappingData) => {
    setMultipleScreenMappingData(mappingData);
    setMapScreenModalInputs(mappingData.mapScreenModalInputs);
    setPublishAlert(true)
  }

  return (
    <Grid container item xs={12} padding={2} style={{ marginTop: "-10px" }}>

      <MaterialReactTable table={table} />

      {/* New Screen */}
      <Dialog ref={modalRef} open={newScreenModal} onClose={hanldeCloseAddScreenModal} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}
        sx={{ '& .MuiPaper-root': { overflowY: "hidden" } }}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366" }}>
          Add Screen
          <IconButton aria-label="close" onClick={hanldeCloseAddScreenModal} style={{ float: "right", color: "gray" }}><CloseIcon /></IconButton>
        </DialogTitle>
        <CreateScreenDialog showAlert={showAlert} addScreenModal={handleAddScreenModal} closeAddScreenModal={hanldeCloseAddScreenModal} />
      </Dialog>

      {/* Edit Screen */}
      <Dialog fullWidth maxWidth="lg" open={editScreenModal} onClose={hanldeCloseEditScreenModal} disableEscapeKeyDown TransitionComponent={Transition}
        sx={{ '& .MuiPaper-root': { overflowY: "hidden" } }}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366", }}>
          Edit Screen & Content Mapping
          <IconButton aria-label="close" style={{ float: "right", color: "gray" }} onClick={hanldeCloseEditScreenModal}><CloseIcon /></IconButton>
        </DialogTitle>
        <EditScreenDialog tableData={tableValues} showAlert={showAlert} updateScreen={handleModifyScreenModal} closeEditScreenModal={hanldeCloseEditScreenModal} />
      </Dialog >

      {/* Map Screens to Content */}
      < Dialog open={mapScreenModal} onClose={hanldeCloseMapScreenModal} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366" }}>
          Map Screens to Content
          <IconButton aria-label="close" onClick={hanldeCloseMapScreenModal} style={{ float: "right", color: "gray" }}><CloseIcon /></IconButton>
        </DialogTitle>
        <MapScreenDialog showAlert={showAlert} mappingConfirmation={handleMappingConfirmation} closeMapScreenModal={hanldeCloseMapScreenModal} />
      </Dialog >

      {/* Row Level Delete Confirmation dialog */}
      < Dialog open={confirmDialog} onClose={handleCloseModal} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle style={{ color: "#003366", fontWeight: "bold" }}>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete this ${" "}`}
            <strong style={{ color: "#003366" }}>{rowData.ic_screen_name}</strong>
            {` screen?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" color="success" onClick={handleConfirmDelete} style={{ textTransform: "none" }}>
            Yes
          </Button>
          <Button variant="contained" size="small" color="error" onClick={handleCancelDelete} style={{ textTransform: "none" }}>
            No
          </Button>
        </DialogActions>
      </Dialog >

      {/* Map Screens to content confirmation */}
      < Dialog open={publishAlert} onClose={handleCloseModal} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle style={{ color: "#003366", fontWeight: "bold" }}>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to update the content on the{" "}
            {mapScreenModalInputs.screenname.map((data, i) => {
              return (
                <Chip size="small" variant="filled" key={i} label={data} style={{ color: "#003366" }} />
              );
            })}{" "}
            screens? By clicking Yes, you are authorizing the display of the
            content on the selected AristoCAST application.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" color="success" onClick={() => handleConfirmPublish(multipleScreenMappingData)} disabled={isPublishing} style={{ textTransform: "none" }}>
            Yes
          </Button>
          <Button variant="contained" size="small" color="error" onClick={() => setPublishAlert(false)} style={{ textTransform: "none" }}>
            No
          </Button>
        </DialogActions>
      </Dialog >

      {/* User role alert */}
      < Dialog open={addScreenAlert} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            setAddScreenAlert(false);
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 1, pl: 3, pr: 2 }} style={{ color: "#003366", fontWeight: "bold" }}>
          Alert
          <IconButton aria-label="close" onClick={() => setAddScreenAlert(false)} style={{ float: "right", color: "gray" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Need Admin privileges to add a New Screen. Please create a Support Ticket if you need this enabled.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small"
            onClick={() =>
              window.open(
                "https://support.intellidash.net/portal/en/newticket",
                "_blank"
              )
            }
            style={{ textTransform: "none", backgroundColor: "#003366" }}
          >
            Create Support Ticket
          </Button>
        </DialogActions>
      </Dialog >
      {
        openProgress &&
        <ContentProgress openProgress={openProgress} onClose={handleCloseProgress} contentId={progressData.content_id} contentType={progressData.contentType} screenData={mapScreenModalInputs} />
      }
    </Grid >
  );
};

export default ScreenTable;
